import RequirementsSection from 'features/requirements/sections/RequirementsSection';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';

const portalConfig = loadPortalConfig();

const RequirementsAdminPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // render
  return (
    <RenderWrapper isVisible={() => portalConfig.enableRequirementPresentation}>
      <Header
        title={tLabels("requirementsAdminPage.title")}
        includeBreadcrumbs
      />
      <ModuleContent>
        <RequirementsSection forAdminUse />
      </ModuleContent>
    </RenderWrapper>
  );
}

export default RequirementsAdminPage;
